import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import Layout from '../components/Layout/index'
import Section from '../components/Section/index'
import SubHeader from '../components/SubHeader/index'
import BlogList from '../components/BlogList/index'

const Blog = ({ data }) => {
  const blogPosts = data.allContentfulBlogPost.edges
    .map(({ node }) => ({
      id: node.id,
      title: node.title,
      date: node.date,
      link: `blogi/${node.title.replace(/ /gi, '-').replace(/[,]/gi, '')}`,
    }))
    .sort((a, b) => {
      return new Date(b.date) - new Date(a.date)
    })

  return (
    <Layout>
      {
        <>
          <Section variant="header">
            <SubHeader heading="Blogi" />
          </Section>
          <Section variant="narrow">
            <BlogList data={blogPosts} />
          </Section>
        </>
      }
    </Layout>
  )
}

Blog.propTypes = {
  data: PropTypes.objectOf(
    PropTypes.objectOf(PropTypes.array.isRequired).isRequired
  ).isRequired,
}

export default Blog

export const query = graphql`
  query {
    allContentfulBlogPost {
      edges {
        node {
          id
          date
          title
        }
      }
    }
  }
`
